import React, { useState, useRef, useEffect } from 'react';
import { TextField, InputAdornment, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  onEnter?: (searchText: string) => void;
  onChange?: (searchText: string) => void;
  id?: string;
  label?: string;
  defaultValue?: string;
}

const TableHeaderSearch: React.FC<React.PropsWithChildren<Props>> = ({ onEnter, onChange, id, label, defaultValue }) => {
  const [searchText, setSearchText] = useState(defaultValue ?? '');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    //Set the actual input box value to the default value if there is one
    if (defaultValue !== undefined) {
      setSearchText(defaultValue);
    } else {
      clearSearch();
    }
  }, [defaultValue]);

  const handleKeyDown = (e: any): void => {
    if (e.key === 'Enter') {
      return onEnter(e.target.value as string);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setSearchText(e.target.value);
    if (!e.target.value.trim()) {
      onEnter('');
    }

    if (onChange) {
      return onChange(e.target.value);
    }
  };

  const clearSearch = (): void => {
    setSearchText('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
    onEnter('');
  };

  const searchHasBtn = searchText.trim().length > 0;

  return (
    <div className={searchHasBtn ? 'search-glass-btn--active' : ''}>
      <TextField
        id={id}
        label={label || 'Search'}
        sx={{ mr: 2 }}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => handleKeyDown(e)}
        onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => handleChange(e)}
        value={searchText}
        inputRef={inputRef}
        className="table-header__search__text"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" className="table-header__search__btns">
              {searchHasBtn ? (
                <>
                  <Button size="small" onClick={() => clearSearch()} sx={{ minWidth: '50px' }} disableRipple className="table-header__search__close">
                    <CloseIcon fontSize="small" />
                  </Button>
                  <Button
                    className="search-glass-btn"
                    variant="contained"
                    onClick={() => {
                      return onEnter(searchText);
                    }}
                  >
                    <SearchIcon />
                  </Button>
                </>
              ) : (
                <SearchIcon />
              )}
            </InputAdornment>
          ),
        }}
        variant="outlined"
      />
    </div>
  );
};

export default TableHeaderSearch;
